<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "misc-wrapper" },
    [
      _c("b-link", { staticClass: "brand-logo" }, [
        _c(
          "h2",
          { staticClass: "brand-text text-primary ml-1" },
          [_c("Logo", { staticClass: "pike-brand-logo" })],
          1
        ),
      ]),
      _c("div", { staticClass: "misc-inner p-2 p-sm-3" }, [
        _c(
          "div",
          { staticClass: "w-100 text-center" },
          [
            _c("h2", { staticClass: "mb-1" }, [
              _vm._v(_vm._s(_vm.$t("PageNotFound")) + " 🕵🏻‍♀️"),
            ]),
            _c("p", { staticClass: "mb-2" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("Oops!") + " 😖 " + _vm.$t("TheRequestedURLWas")
                  ) +
                  " "
              ),
            ]),
            _c(
              "b-button",
              {
                staticClass: "mb-2 btn-sm-block",
                attrs: { variant: "primary", to: { path: "/" } },
              },
              [_vm._v(" " + _vm._s(_vm.$t("BackToHome")) + " ")]
            ),
            _c("imgUrl"),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/error/Error404.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import core_layouts_components_Logo_vue from '@core/layouts/components/Logo.vue';
import store_index from '@/store/index';
import assets_images_pages_error_svg from '@/assets/images/pages/error.svg';
import assets_rashi_coin_logo_svg from '@/assets/rashi-coin/logo.svg';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable global-require */





export default ({
  render,
  staticRenderFns,
  components: {
    VuexyLogo: core_layouts_components_Logo_vue,
    BLink: bootstrapvue["BLink"],
    BButton: bootstrapvue["BButton"],
    BImg: bootstrapvue["BImg"],
    imgUrl: assets_images_pages_error_svg,
    Logo: assets_rashi_coin_logo_svg
  },
  data() {
    return {
      downImg: require("@/assets/images/pages/error.svg")
    };
  },
  computed: {
    imgUrl() {
      if (store_index.state.appConfig.layout.skin === "dark") {
        this.downImg = require("@/assets/images/pages/error-dark.svg");
        return this.downImg;
      }
      return this.downImg;
    }
  }
});

//# sourceURL=webpack:///./src/views/error/Error404.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
.misc-wrapper {
  display: flex;
  flex-basis: 100%;
  min-height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.misc-wrapper .misc-inner {
  position: relative;
  max-width: 750px;
}
.misc-wrapper .brand-logo {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 2rem;
}
[dir] .misc-wrapper .brand-logo {
  margin: 0;
}
[dir=ltr] .misc-wrapper .brand-logo {
  left: 2rem;
}
[dir=rtl] .misc-wrapper .brand-logo {
  right: 2rem;
}
.misc-wrapper .brand-logo .brand-text {
  font-weight: 600;
}
</style>
